module.exports = __webpack_public_path__ + "img/fstvideo.b2e2b2a7.png";